.folderRowChartMeta {
	align-items: center;
	column-gap: 0.375rem;
	display: flex;
	flex-shrink: 0;
	justify-content: flex-end;
	margin-left: auto;
	min-width: 0;
}

.folderRowChartCount {
	flex-shrink: 0;
	font-size: 1.125rem;
	font-variant-numeric: tabular-nums;
	text-align: right;
	width: 7ch;
}

/** Sizes to content on large screens (up to 18rem); full width when stacked on mobile. */
.folderRowTitle {
	box-sizing: border-box;
	font-size: 1.125rem;
	max-width: 100%;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	@media (width >= 992px) {
		flex: 0 0 var(--folder-title-w, 10rem);
		max-width: var(--folder-title-w, 10rem);
		min-width: var(--folder-title-w, 10rem);
	}
}

@keyframes folder-row-highlight-intro {
	0% {
		background-color: transparent;
		border-color: var(--bs-border-color);
		box-shadow: 0 0 0 color-mix(in srgb, var(--bs-primary) 0%, transparent);
		transform: translateY(0);
	}
	50% {
		background-color: color-mix(in srgb, var(--bs-primary) 18%, var(--bs-body-bg));
		border-color: color-mix(in srgb, var(--bs-primary) 65%, var(--bs-border-color));
		box-shadow:
			0 0.25rem 1.15rem color-mix(in srgb, var(--bs-primary) 32%, transparent),
			0 0 0 1px color-mix(in srgb, var(--bs-primary) 40%, transparent);
		transform: translateY(-3px);
	}
	100% {
		background-color: color-mix(in srgb, var(--bs-primary) 12%, var(--bs-body-bg));
		border-color: color-mix(in srgb, var(--bs-primary) 58%, var(--bs-border-color));
		box-shadow:
			0 0.22rem 0.85rem color-mix(in srgb, var(--bs-primary) 28%, transparent),
			0 0 0 1px color-mix(in srgb, var(--bs-primary) 38%, transparent),
			inset 3px 0 0 0 var(--bs-primary);
		transform: translateY(-1px);
	}
}

.folderRow {
	border: 1px solid var(--bs-border-color);
	border-radius: var(--bs-border-radius);
	color: inherit;
	display: block;
	margin-bottom: 0.2rem;
	padding: 0.2rem 0.75rem;
	text-decoration: none;
	transition:
		border-color 0.12s ease,
		box-shadow 0.12s ease,
		transform 0.12s ease;

	&:hover {
		border-color: var(--bs-primary);
		box-shadow: 0 0.35rem 1rem rgba(0, 0, 0, 0.12);
		color: inherit;
		text-decoration: none;
		transform: translateY(-2px);
	}

	&:focus-visible {
		outline: 2px solid var(--bs-primary);
		outline-offset: 2px;
	}
}

/** Row for the folder that matches `highlightFolderSlug`; intro bumps when the overview accordion opens (`FolderTablePage`). */
.folderRowHighlighted {
	animation: folder-row-highlight-intro 1.15s cubic-bezier(0.33, 0.82, 0.35, 1) both;
	border-width: 2px;

	&:hover {
		background-color: color-mix(in srgb, var(--bs-primary) 16%, var(--bs-body-bg));
		border-color: color-mix(in srgb, var(--bs-primary) 72%, var(--bs-border-color));
		box-shadow:
			0 0.35rem 1.1rem color-mix(in srgb, var(--bs-primary) 30%, transparent),
			0 0 0 1px color-mix(in srgb, var(--bs-primary) 42%, transparent),
			inset 3px 0 0 0 var(--bs-primary);
	}

	&:focus-visible {
		outline: 2px solid var(--bs-primary);
		outline-offset: 2px;
	}

	@media (prefers-reduced-motion: reduce) {
		animation: none;
		background-color: color-mix(in srgb, var(--bs-primary) 12%, var(--bs-body-bg));
		border-color: color-mix(in srgb, var(--bs-primary) 55%, var(--bs-border-color));
		border-left-width: 6px;
		border-width: 2px;
		box-shadow:
			0 0.18rem 0.65rem color-mix(in srgb, var(--bs-primary) 22%, transparent),
			inset 3px 0 0 0 var(--bs-primary);
		padding-inline-start: calc(0.75rem - 4px);
	}
}
